import { createAsyncThunk } from "@reduxjs/toolkit";
import { objectsKiiAPI } from "libs/apiClient/ObjectsKii";
import { filesAPI } from "libs/apiClient/Files";

export const getData = createAsyncThunk(
	"stepSixSlice/getData",
	async (
		{
			organizationId,
			formationMode,
			part,
			count,
			setLoad,
		}: { organizationId: number; formationMode: boolean; part: number; count: number; setLoad?: () => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportListDetail(organizationId, {
					page: part,
					num: count,
					exportable: formationMode,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<IData>(
			// 		`/objects_kii/${organizationId}/export/list?page=${part}&num=${count}&exportable=${formationMode}`,
			// 	)
			// ).data;
			if (setLoad) setLoad();
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getSearchedData = createAsyncThunk(
	"stepSixSlice/getSearchedData",
	async (
		{
			organizationId,
			searchValue,
			formationMode,
			part,
			count,
			setLoad,
		}: {
			organizationId: number;
			searchValue: string;
			formationMode: boolean;
			part: number;
			count: number;
			setLoad?: () => void;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportListDetail(organizationId, {
					page: part,
					num: count,
					query: searchValue,
					exportable: formationMode,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<IData>(
			// 		`/objects_kii/${organizationId}/export/list?page=${part}&num=${count}&query=${searchValue}&exportable=${formationMode}`,
			// 	)
			// ).data;
			if (setLoad) setLoad();

			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getBatchObjects = createAsyncThunk(
	"stepSixSlice/getBatchObjects",
	async (
		{
			organizationId,
			batchId,
			part,
			count,
			setLoad,
		}: { organizationId: number; batchId: number; part: number; count: number; setLoad?: () => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportListDetail(organizationId, {
					page: part,
					num: count,
					bundle_id: batchId,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<IData>(`/objects_kii/${organizationId}/export/list?bundle_id=${batchId}&page=${part}&num=${count}`)
			// ).data;
			if (setLoad) setLoad();
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getSearchedBatchObjects = createAsyncThunk(
	"stepSixSlice/getSearchedBatchObjects",
	async (
		{
			organizationId,
			batchId,
			searchValue,
			part,
			count,
			setLoad,
		}: {
			organizationId: number;
			batchId: number;
			searchValue: string;
			part: number;
			count: number;
			setLoad?: () => void;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportListDetail(organizationId, {
					page: part,
					num: count,
					query: searchValue,
					bundle_id: batchId,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<IData>(
			// 		`/objects_kii/${organizationId}/export/list?bundle_id=${batchId}&page=${part}&num=${count}&query=${searchValue}`,
			// 	)
			// ).data;
			if (setLoad) setLoad();
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const formDocumentPackage = createAsyncThunk(
	"stepSixSlice/formDocumentPackage",
	async (
		{
			organizationId,
			allCheckedGlobal,
			attachmentList,
			excludedObjects,
		}: { organizationId: number; allCheckedGlobal: boolean; attachmentList: number[]; excludedObjects: number[] },
		{ rejectWithValue },
	) => {
		try {
			return await objectsKiiAPI.exportBundleCreate(organizationId, {
				all: allCheckedGlobal,
				include: allCheckedGlobal ? [] : attachmentList,
				exclude: allCheckedGlobal ? excludedObjects : [],
			}).then(r=>r.data);
			// return (
			// 	await $api.post<IData>(`/objects_kii/${organizationId}/export/bundle`, {
			// 		all: allCheckedGlobal,
			// 		include: allCheckedGlobal ? [] : attachmentList,
			// 		exclude: allCheckedGlobal ? excludedObjects : [],
			// 	})
			// ).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getBatches = createAsyncThunk(
	"stepSixSlice/getBatches",
	async (organizationId: number, { rejectWithValue }) => {
		try {
			return await objectsKiiAPI.exportBundleListDetail(organizationId).then((r) => r.data);
			// return (await $api<IBatch[]>(`/objects_kii/${organizationId}/export/bundle/list`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getDocumentArchive = createAsyncThunk(
	"stepSixSlice/getDocumentArchive",
	async ({ organizationId, batchId }: { organizationId: number; batchId: number }, { rejectWithValue }) => {
		try {
			return await objectsKiiAPI.exportBundleDetail(organizationId, { bundle_id: batchId }).then((r) => r.data);
			// return (await $api<any>(`/objects_kii/${organizationId}/export/bundle?bundle_id=${batchId}`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const dowloadDocumentArchive = createAsyncThunk(
	"stepSixSlice/dowloadDocumentArchive",
	async ({ name, archiveURL }: { name: string; archiveURL: string }, { rejectWithValue }) => {
		try {
			return await filesAPI.list(archiveURL, { format: "blob" }).then((response) => {
				// create file link in browser's memory
				const href = URL.createObjectURL(response.data);

				// create "a" HTML element with href to file & click
				const link = document.createElement("a");
				link.href = href;
				link.setAttribute("download", `${name}.zip`); //or any other extension
				document.body.appendChild(link);
				link.click();

				// clean up "a" element & remove ObjectURL
				document.body.removeChild(link);
				URL.revokeObjectURL(href);
			});
			// return $api({
			// 	url: `/files/${archiveURL}`, //your url
			// 	method: "GET",
			// 	responseType: "blob", // important
			// }).then((response) => {
			// 	// create file link in browser's memory
			// 	const href = URL.createObjectURL(response.data);
			//
			// 	// create "a" HTML element with href to file & click
			// 	const link = document.createElement("a");
			// 	link.href = href;
			// 	link.setAttribute("download", `${name}.zip`); //or any other extension
			// 	document.body.appendChild(link);
			// 	link.click();
			//
			// 	// clean up "a" element & remove ObjectURL
			// 	document.body.removeChild(link);
			// 	URL.revokeObjectURL(href);
			// });
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
